import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Dropzone } from './Dropzone';
import { Progress } from './Progress';
import Styles from './Upload.module.scss';
import { UiActions } from 'state/actions/UiActions';
import { connect } from 'react-redux';

export class Upload extends Component {
  state = {
    files: [],
    progress: {},
    uploading: false,
    successful: false,
    response: [],
    isEmptyInputFileAndNotClicked: false,
  };

  clearState = () => {
    this.setState({
      files: [],
      progress: {},
      uploading: false,
      successful: false,
      response: [],
      isEmptyInputFileAndNotClicked: false,
      openExplorer: false,
    });
  };

  /**
   * @param {File[]} files
   */
  onFilesAdded = files => {
    this.setState({
      files: [...files],
    });

    if (this.props.returnFiles) {
      this.props.onUploadFinish(files);
    }
  };

  uploadFiles = async () => {
    if (this.state.uploading) return;

    if (this.state.files?.length === 0) {
      this.setState({
        isEmptyInputFileAndNotClicked: true,
        openExplorer: !this.state.openExplorer,
      });

      return;
    }

    this.setState({
      progress: {},
      uploading: true,
    });

    const promises = [];
    this.state.files.forEach(file => {
      promises.push(this.uploadRequest(file));
    });

    try {
      const response = await Promise.all(promises);

      const _response = response.filter(item => {
        return !item.status && !item.statusCode;
      });

      if (_response.length < 1) {
        throw new Error('');
      }

      this.props.publishSuccessAlert('Arquivo(s) enviado(s) com sucesso');

      this.setState(
        {
          successful: true,
          uploading: false,
          response: _response,
        },
        () => {
          if (this.props.onUploadFinish) {
            this.props.onUploadFinish(_response);
            this.clearState();
          }
        }
      );

      return;
    } catch (e) {
      this.props.publishErrorAlert('Erro ao enviar arquivo(s)');

      this.setState({
        successful: false,
        uploading: false,
      });
    }
  };

  /**
   * @param {File} file
   */
  uploadRequest = async file => {
    const { uploadUrl, headers, fields, fileInputName } = this.props;

    return new Promise((resolve, reject) => {
      const _xhr = new XMLHttpRequest();

      _xhr.onload = () => {
        resolve(JSON.parse(_xhr.response));
      };

      _xhr.upload.addEventListener('progress', evt => {
        if (evt.lengthComputable) {
          const copy = { ...this.state.progress };
          copy[file.name] = {
            state: 'pending',
            percentage: (evt.loaded / evt.total) * 100,
          };

          this.setState({
            progress: copy,
          });
        }
      });

      _xhr.upload.addEventListener('load', evt => {
        const copy = { ...this.state.progress };
        copy[file.name] = {
          state: 'done',
          percentage: (evt.loaded / evt.total) * 100,
        };

        this.setState({
          progress: copy,
        });
      });

      _xhr.upload.addEventListener('error', evt => {
        const copy = { ...this.state.progress };
        copy[file.name] = {
          state: 'error',
          percentage: 0,
        };

        this.setState({
          progress: copy,
        });

        reject(_xhr.response);
      });

      const formData = new FormData();
      formData.append(fileInputName, file, file.name);
      formData.append('type', file.type);

      if (Object.keys(fields).length > 0) {
        Object.keys(fields).forEach(key => {
          formData.append(key, fields[key]);
        });
      }

      _xhr.open('POST', uploadUrl);
      if (Object.keys(headers).length > 0) {
        Object.keys(headers).forEach(key => {
          _xhr.setRequestHeader(key, headers[key]);
        });
      }
      _xhr.send(formData);
    });
  };

  renderActions = () => {
    const { clearButtonText, uploadButtonText, returnFiles } = this.props;

    if (returnFiles === true) return null;
    const { files, uploading, successful } = this.state;

    // if (successful) {
    //   return (
    //     <button
    //       onClick={this.clearState}>
    //       {clearButtonText}
    //     </button>
    //   );
    // }
    return (
      <button
        className={'btn btn-sm btn-light-lime align-self-center'}
        onClick={this.uploadFiles}
      >
        {uploadButtonText}
      </button>
    );
  };

  /**
   * @param {File} file
   */
  renderProgress = file => {
    const uploadProgress = this.state.progress[file.name];
    if (this.state.uploading || this.state.successful) {
      return (
        <Progress progress={uploadProgress ? uploadProgress.percentage : 0} />
      );
    }
  };

  render() {
    const dropzoneAttributes = {
      multiple: this.props.multiple,
      onDrop: this.onFilesAdded,
      acceptFilesType: this.props.acceptFilesType,
      isEmptyInputFileAndNotClicked: this.state.isEmptyInputFileAndNotClicked,
      openExplorer: this.state.openExplorer,
    };
    if (this.props.dropzoneClassName) {
      dropzoneAttributes.className = this.props.dropzoneClassName;
    }
    if (this.props.disabledClassName) {
      dropzoneAttributes.disabledClassName =
        this.props.dropzoneDisabledClassName;
    }
    if (this.props.highlightClassName) {
      dropzoneAttributes.highlightClassName =
        this.props.dropzoneHighlightClassName;
    }

    return (
      <div id={this.props.id} className={classnames(this.props.className)}>
        {/*<pre style={{maxHeight: "320px",overflow:"scroll"}}>*/}
        {/*  {JSON.stringify(this.state, null, 2)}*/}
        {/*</pre>*/}

        <Dropzone {...dropzoneAttributes} />

        <div className={classnames(this.props.fileListClass)}>
          {this.state.files.map((item, key) => {
            return (
              <div key={key}>
                <span>{item.name}</span>
                {this.renderProgress(item)}
              </div>
            );
          })}

          {this.renderActions()}
        </div>
      </div>
    );
  }
}

Upload.defaultProps = {
  headers: {},
  fields: {},
  fileInputName: 'files',
  clearButtonText: 'Limpar',
  uploadButtonText: 'Enviar',
  onUploadFinish: null,
  multiple: false,
  className: Styles['upload'],
  dropzoneClassName: Styles['dropzone'],
  dropzoneDisabledClassName: Styles['disabled'],
  dropzoneHighlightClassName: Styles['highlight'],
  returnFiles: false,
};

Upload.propTypes = {
  uploadUrl: PropTypes.string.isRequired,
  headers: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
  ),
  fields: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
  ),
  fileInputName: PropTypes.string,
  clearButtonText: PropTypes.string,
  uploadButtonText: PropTypes.string,
  onUploadFinish: PropTypes.func,
  multiple: PropTypes.bool,
  accpetFilesType: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.objectOf(PropTypes.bool),
  ]),
  dropzoneClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.objectOf(PropTypes.bool),
  ]),
  dropzoneDisabledClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.objectOf(PropTypes.bool),
  ]),
  dropzoneHighlightClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.objectOf(PropTypes.bool),
  ]),
  returnFiles: PropTypes.bool,
};

const mapStateToProps = state => ({
  store: state,
  token: state.token.data.Authorization,
});

const mapDispatchToProps = dispatch => ({
  publishSuccessAlert: message => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: message => {
    dispatch(UiActions.publishErrorAlert(message));
  },
});

Upload = connect(mapStateToProps, mapDispatchToProps)(Upload);
